var _path, _path2, _path3, _path4, _path5, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9204 125.83C100.715 125.83 125.68 100.866 125.68 70.0708C125.68 39.2758 100.715 14.3115 69.9204 14.3115C39.1254 14.3115 14.1611 39.2758 14.1611 70.0708C14.1611 100.866 39.1254 125.83 69.9204 125.83Z",
    fill: "#FBFBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8243 102.406L61.3559 34.7831C63.2069 31.5346 67.8383 31.3927 69.8847 34.5218L112.484 99.659C114.622 102.927 112.356 107.274 108.453 107.393L27.3217 109.879C23.4189 109.999 20.8912 105.799 22.8243 102.406Z",
    fill: "#68E5BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.3269 97.5763L61.6905 47.7522C63.8439 44.2187 69.1123 44.6809 70.6176 48.5352L91.8435 102.885C93.1926 106.339 90.4435 110.008 86.7491 109.684L35.1596 105.159C31.4652 104.835 29.3969 100.743 31.3269 97.5763Z",
    fill: "#7C7C7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2384 106.202L67.2804 58.3486C69.4939 55.3258 74.1229 55.7215 75.7913 59.0762L102.203 112.183C103.94 115.675 101.187 119.723 97.3003 119.391L35.8466 114.138C31.96 113.806 29.9338 109.349 32.2384 106.202Z",
    fill: "#ECECEB",
    stroke: "#ECECEB",
    strokeWidth: 9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3277 80.7812C67.3132 78.0962 69.6074 75.9784 72.2826 76.2071C74.9579 76.4358 76.8593 78.9122 76.3893 81.5558L73.923 95.429C73.6256 97.1018 72.1017 98.2719 70.4088 98.1272C68.716 97.9825 67.4127 96.5707 67.4036 94.8717L67.3277 80.7812Z",
    fill: "#3C3C3B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.4414,
    y: 98.9053,
    width: 7.77364,
    height: 7.77364,
    rx: 3.88682,
    transform: "rotate(4.88588 66.4414 98.9053)",
    fill: "#3C3C3B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIllustration);
export default __webpack_public_path__ + "static/media/warning-illustration.23da4942fc33d7e673af02d2ede1dc77.svg";
export { ForwardRef as ReactComponent };